import { GroupedSingleSelect } from '@eggplant/pattern-library'
import { PollAiEnvironmentsRequest } from '@eggplant/api-requests'
import type {
  EnvironmentResponse,
  GetAgentsParams
} from '@eggplant/types'
import type { Props } from '../interfaces'

const params = {
  agent_type: 'DESIGN'
} as GetAgentsParams

const agentMapper = ({ id, name, isconnected }: EnvironmentResponse) => ({
  label: name,
  value: id.toString(),
  isDisabled: !isconnected
})

const getGroupOptions = (agents: EnvironmentResponse[]) => ['Connected', 'Disconnected'].map(group => ({
  label: group,
  options: agents
    .filter(({ isconnected }: EnvironmentResponse) => isconnected === (group === 'Connected'))
    .map(agentMapper)
}))

const getValue = (agents: EnvironmentResponse[], selectedAgentId: string) => {
  const agent = agents.find(agent => Number(agent.id) === Number(selectedAgentId))

  return agent?.isconnected
    ? agent.id.toString()
    : ''
}

interface CustomProps extends Omit<Props, 'onChange'> {
  onChange: (agent?: EnvironmentResponse) => void
}

const SelectDesignEnvironment = ({
  label,
  onChange,
  value
}: CustomProps) => {
  const getHandleChange = (agents: EnvironmentResponse[]) =>
    (agentId: string) => {
      const agent = agents.find(agentOption =>
        agentOption.id.toString() === agentId
      )

      if (!agent) return

      onChange(agent)
    }

  return (
    <PollAiEnvironmentsRequest
      isPolling
      params={params}
    >
      {
        (data: EnvironmentResponse[]) =>
          <GroupedSingleSelect
            groups={getGroupOptions(data)}
            isRequired
            label={label}
            onChange={getHandleChange(data)}
            prompt='Select Environment'
            value={getValue(data, value)}
          />
      }
    </PollAiEnvironmentsRequest>
  )
}

export default SelectDesignEnvironment
